// @generated by protoc-gen-connect-es v0.10.0 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.assessment.llm.apis.proto (package geneo.lms.assessment.llm.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { EvaluateAnswerRequest, EvaluateAnswerResponse } from "./lms.assessment.llm.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.lms.assessment.llm.apis.LLMEvaluatorServiceV1
 */
export const LLMEvaluatorServiceV1 = {
  typeName: "geneo.lms.assessment.llm.apis.LLMEvaluatorServiceV1",
  methods: {
    /**
     * Evaluate student's answer using LLM
     *
     * @generated from rpc geneo.lms.assessment.llm.apis.LLMEvaluatorServiceV1.evaluateAnswer
     */
    evaluateAnswer: {
      name: "evaluateAnswer",
      I: EvaluateAnswerRequest,
      O: EvaluateAnswerResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

